import gql from 'graphql-tag'

const reservationInternalStockChangesGetQuery = gql`
  query reservationInternalStockChangesGet($criteria: Object) {
    reservationInternalStockChangesGet(input: { criteria: $criteria, nested: true })
      @rest(type: "ReservationInternalStockChangesResult", method: "POST", path: "reservation/internal-stock-change/list") {
      results
    }
  }
`

export default reservationInternalStockChangesGetQuery
